import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Typography } from 'seagull';
import styles from './ServicesSection.module.scss';
export default function ServicesSection(props) {
    const { title, subtitle, hasOptionalServices, category, children, testId } = props;
    return /*#__PURE__*/ _jsxs("li", {
        className: classNames(styles.section, styles[category]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.sectionHeader,
                children: [
                    hasOptionalServices && category !== 'variable' && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        testId: testId && testId + '-has-optional',
                        children: "Starts at"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: testId && testId + '-title',
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        weight: "normal",
                        testId: testId && testId + '-subtitle',
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("ul", {
                children: children
            })
        ]
    });
}
